import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Discover",
    desc: "We listen, audit and frame the problem clearly — the brief gets sharper before a single line of code.",
  },
  {
    n: "02",
    title: "Design",
    desc: "Wireframes, flows and a UI direction your customers will feel. Approved before we ship pixels.",
  },
  {
    n: "03",
    title: "Build",
    desc: "Senior engineers ship in weekly slices. You see real working software, not slide decks.",
  },
  {
    n: "04",
    title: "Launch",
    desc: "QA, deployment, analytics, handover docs. We make sure go-live feels uneventful — the good kind.",
  },
  {
    n: "05",
    title: "Scale",
    desc: "Ongoing iteration, automation and growth work. We stay close as long as it's useful.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="relative py-24 md:py-36 bg-[#FDFCFB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="caption mb-6">Process</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05] max-w-3xl">
              A studio rhythm <span className="italic">tuned for speed</span> and care.
            </h2>
          </div>
          <p className="max-w-md text-[#6B6A68] md:text-right">
            Five clear stages, weekly demos, zero surprises. Most engagements
            move from kickoff to production in 4–10 weeks.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 border-t border-l border-[#E8E6E1]">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="relative p-8 md:p-10 border-r border-b border-[#E8E6E1] bg-[#FDFCFB] hover:bg-[#F5F4F0] transition-colors duration-500 min-h-[260px] md:min-h-[320px] flex flex-col"
            >
              <span className="font-mono-tech text-xs text-[#6B6A68] mb-10">
                {s.n}
              </span>
              <h3 className="font-serif-display text-3xl md:text-4xl text-[#1A1A1A] mb-4">
                {s.title}
              </h3>
              <p className="text-sm text-[#6B6A68] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
